export default {
  Studies: "Studies",
  Layouts: "Grid Layout",
  Sync: "Sync",
  scroll: "Scroll",
  wwwc: "Window Level",
  zoom: "Zoom",
  general: "General",
  zooming: "Zoom",
  annotation: "Measurements",
  rotating: "Rotate",
  Pan: "Pan",
  Wwwc: "Levels",
  WwwcRegion: "Level region",
  Magnify: "Magnify",
  Zoom: "Zoom",
  Screen: "Capture",
  Rotate: "Rotate",
  Flip: "Flip",
  Reset: "Reset",
  Eraser: "Eraser",
  ArrowAnnotate: "A - Arrow",
  Bidirectional: "Bidirectional",
  CobbAngle: "Angle",
  EllipticalRoi: "E - Ellipse",
  EllipticalROI: "E - Ellipse",
  FreehandRoi: "Freehand Roi",
  Length: "L - Length",
  Probe: "Probe",
  RectangleRoi: "Rectangle",
  TextMarker: "Text marks",
  DragProbe: "Probe",
  ScaleOverlay: "Scales",
  OrientationMarkers: "OrientationMarkers",
  Brush: "Arbitrary path",
  CircleScissors: "Ellipse",
  FreehandScissors: "Freehand",
  RectangleScissors: "Rectangle",
  Invert: "Invert",
  Clip: "Cine",
  Series: "Series",
  Report: "Report",
  patientId: "Patient ID",
  fullname: "Patient Name",
  birthday: "Patient Date of birth",
  studyCreatedAt: "Study Date",
  old: "Age",
  patientSex: "Sex",
  "Result AI": "AI Report",
  "Download dicom": "Download Series",
  "Download report": "Download Report",
  Loading: "Loading",
  Cached: "in cache",
  male: "Male",
  female: "Female",
  Copy: "Copy text",
  "Copy ok": "Copied",
  "Copy error": "Copied error",
  Anonymized: "Anonymized",
  StackScroll: "Stack scroll",
  "Result after upload message": "Report will be available after AI processing",
  "Result ai error message":
    "Failed to process the study, please try to upload another study",
  error: "Error",
  "dcm cannot loading": "Loading .dcm file failed",
  "error read dcm": "Read study info failed",
  ai: "AI Series",
  original: "Original Series",
  "How to use title": "Manual for the service",
  "How to use": "Manual",
  "ai accept caption": "Is the result of this AI analysis correct?",
  "thx for feedback": "Thanks for the feedback!",
  SelectedAccept: {
    1: "You noted that the result",
    2: "of the AI ​​analysis is",
  },
  "accept yes": "correct",
  "accept no": "incorrect",
  "View title": "Study | " + process.env.VUE_APP_INSTALL_NAME + "",
  Share: "Share",
  "Share done": "Done",
  "Share about": "Link copied",
  "Cancel preset": "Default",
  Description: "Report",
  "About study": "Your answer",
  CheckReport: "Submit",
  "Your description": "Your report",
  "Best description": "Correct report",
  "Teacher comment": "Teacher’s comment",
  "Answer exist": "Completed",
  "Answer not exist": "No answer",
  from: "from",
  "Skip all": "Skip all",
  "Add screenshot": "Capture window",
  "About screen info":
    "You can draw measurements or ROIs in the viewer and click on this button. Screenshots will be automatically attached to your answer",
  "Screenshot doned": "Done",
  PlanarFreehandROI: "R - Freehand ROI",
  MPR: "MPR",
  "Disable MPR First": "Turn off MPR",
  Crosshairs: "Crosshairs",
  "MPR: only for 2+": "Series is not reconstructable",
  "MPR: hpu tier == 0": "Your device GPU cannot perform MPR",
  "MPR: modality not support": "Modality <modality> is not reconstructable",
  "Cannot loading screen -- adblock":
    "Please turn off all chrome extenstions as AdBlock и Location Guard and try again",
  "Cannot loading screen -- s3 request": "Try again later",
  "Cannot loading screen -- upload": "Try again later",
  voi: "VOI",
  camera: "Pan/Zoom",
  "Remove?": "Delete?",
  Support: "Support",
  "Support info": "You can ask a question or report a problem",
  "Send work?": "Complete and submit the work for review?",
  shareAIResult:
    "Look at AI report on " + process.env.VUE_APP_INSTALL_NAME + " Platform:",
  "Edit study": "Edit description",
};
